export default "__VITE_ASSET__XH4QLcSM__"